// Методы API оболочки (web/server/stoweb/routes/projects.py и build.py): корзина, готовые файлы экспорта,
// «Открыть в Word», папка отчётов. Общий клиент - core/api.ts (api.get / api.post с токеном сессии).
import { api } from '../../core/api';

const enc = encodeURIComponent;
const P = (pid: string) => `/api/projects/${enc(pid)}`;

export interface TrashItem { id: string; name: string; title: string; type: string; trashed: string;
  /** удалён администратором: только для сведения (восстановить может только администратор) */
  byAdmin?: boolean; trashedBy?: string }
export interface ExportFile { name: string; size: number; mtime: number; kind: 'docx' | 'pdf' | 'zip' }
export interface ProjectCard {
  student: string; student_short: string; group: string; year: string; city: string; university: string; branch: string;
  teacher: string; teacherPos: string; variant: string; firstHeading: string; pdf: boolean; pdfTime: number;
  counts: { words: number; figures: number; tables: number; formulas: number; sections: number };
}

export const shellApi = {
  trash: () => api.get<{ items: TrashItem[] }>('/api/projects-trash'),
  restoreTrash: (id: string) => api.post<{ id: string }>('/api/projects-trash/restore', { id }),
  purgeTrash: (ids: string[]) => api.post<{ purged: string[] }>('/api/projects-trash/purge', { ids }),
  revealRoot: () => api.post<{ path: string }>('/api/projects-reveal', {}),
  exports: (pid: string) => api.get<{ files: ExportFile[] }>(`${P(pid)}/exports`),
  openWord: (pid: string, file?: string) => api.post<{ file: string }>(`${P(pid)}/open-word`, file ? { file } : {}),
};
